module.exports = __webpack_public_path__ + "static/2019-publicArt-3-e1195db43b50cca845ad7fc4357635fe.jpg";